/* POLKA DOTS – desktop menu (snippets/pd-dmenu.liquid). Mouse le jao to panel khulta hai, tasveerein tabhi aati hain.
   Ginti notify.polkadots.pk/h.php par (s = 'dmenu', phone wale 'menu' se alag) – sirf kya dabaya, koi customer data nahi. */
(function () {
  'use strict';
  var d = document, W = window, nav = d.getElementById('pd-dm');
  if (!nav || nav.dataset.ready) return; nav.dataset.ready = 1;
  var FINE = W.matchMedia && W.matchMedia('(hover: hover) and (pointer: fine)').matches;
  var cur = null, tOpen = 0, tClose = 0, tSeen = 0, dim = d.createElement('div');
  dim.className = 'pd-dm-dim'; nav.appendChild(dim); // nav ke andar: panel ke saath ek hi tah (stacking) mein

  function slug(t) { return String(t || '').toLowerCase().replace(/&/g, ' ').replace(/[^a-z0-9%]+/g, '-').replace(/^-+|-+$/g, '').slice(0, 50); }
  function txt(el) { if (!el) return ''; var c = el.cloneNode(true); [].forEach.call(c.querySelectorAll('svg,.pd-dm-tag'), function (x) { x.remove(); }); return c.textContent.replace(/\s+/g, ' ').trim(); }
  function send(k, p) { try { if (navigator.sendBeacon) navigator.sendBeacon('https://notify.polkadots.pk/h.php', new Blob([JSON.stringify({ s: 'dmenu', k: k, p: p || '' })], { type: 'text/plain' })); } catch (e) { } }
  function deptOf(el) { var li = el.closest('.pd-dm-it'); return slug(txt(li && li.querySelector('.pd-dm-top'))) || 'menu'; }

  function place(li) {
    var top = Math.max(0, Math.round(nav.getBoundingClientRect().bottom));
    var p = li.querySelector('.pd-dm-pan'); if (p) p.style.top = top + 'px';
    dim.style.top = top + 'px'; d.documentElement.style.setProperty('--pd-dm-top', top + 'px');
  }
  function imgs(li) { [].forEach.call(li.querySelectorAll('img[data-src]'), function (i) { i.src = i.getAttribute('data-src'); i.removeAttribute('data-src'); }); }
  function open(li) {
    clearTimeout(tClose);
    if (cur === li) return;
    if (cur) shut(cur);
    if (!li.classList.contains('has-pan')) { cur = null; dim.classList.remove('on'); return; }
    cur = li; imgs(li); place(li);
    li.classList.add('is-open'); dim.classList.add('on');
    var a = li.querySelector('.pd-dm-top'); if (a) a.setAttribute('aria-expanded', 'true');
    clearTimeout(tSeen); tSeen = setTimeout(function () { if (cur === li) send('mcat', deptOf(li)); }, 600); // sirf jo sach mein dekha
  }
  function shut(li) {
    li.classList.remove('is-open');
    var a = li.querySelector('.pd-dm-top'); if (a) a.setAttribute('aria-expanded', 'false');
    if (cur === li) { cur = null; dim.classList.remove('on'); }
  }
  function closeAll() { clearTimeout(tOpen); if (cur) shut(cur); }

  [].forEach.call(nav.querySelectorAll('.pd-dm-it'), function (li) {
    li.addEventListener('mouseenter', function () { if (!FINE) return; clearTimeout(tClose); clearTimeout(tOpen); tOpen = setTimeout(function () { open(li); }, cur ? 0 : 90); });
    li.addEventListener('mouseleave', function () { if (!FINE) return; clearTimeout(tOpen); tClose = setTimeout(function () { if (cur === li) shut(li); }, 160); });
  });
  // pehli dafa patti par mouse aaye to sab panels ki tasveerein fursat mein (taake khulte hi tayyar hon)
  nav.addEventListener('mouseenter', function once() {
    nav.removeEventListener('mouseenter', once);
    (W.requestIdleCallback || function (f) { setTimeout(f, 400); })(function () { [].forEach.call(nav.querySelectorAll('.pd-dm-it.has-pan'), function (li, i) { if (i < 4) imgs(li); }); });
  });
  // keyboard: Tab se upar ke naam par aao to panel khule, Esc band
  nav.addEventListener('focusin', function (e) { var li = e.target.closest('.pd-dm-it'); if (li && e.target.classList.contains('pd-dm-top')) open(li); });
  d.addEventListener('keydown', function (e) { if (e.key === 'Escape' && cur) { var a = cur.querySelector('.pd-dm-top'); closeAll(); if (a) a.focus(); } });
  dim.addEventListener('mouseenter', function () { if (FINE) { clearTimeout(tClose); tClose = setTimeout(closeAll, 120); } });
  dim.addEventListener('click', closeAll);
  W.addEventListener('scroll', function () { if (cur) closeAll(); }, { passive: true });
  W.addEventListener('resize', function () { if (cur) place(cur); }, { passive: true });

  // clicks: touch laptop par pehla tap panel kholta hai; ginti
  nav.addEventListener('click', function (e) {
    var t = e.target, el;
    if ((el = t.closest('.pd-dm-ar'))) {
      e.preventDefault();
      var pics = el.closest('.pd-dm-pics'), tr = pics.querySelector('.pd-dm-track'), n = tr.children.length,
        np = +getComputedStyle(pics.closest('.pd-dm-grid')).getPropertyValue('--np') || 3, i = Math.max(0, Math.min(n - np, (+tr.dataset.i || 0) + (+el.dataset.dir)));
      tr.dataset.i = i; var w = tr.children[0] ? tr.children[0].getBoundingClientRect().width + 4 : 0;
      tr.style.transform = 'translateX(' + (-i * w) + 'px)';
      var bs = pics.querySelectorAll('.pd-dm-ar'); bs[0].disabled = i <= 0; bs[1].disabled = i >= n - np;
      return;
    }
    if ((el = t.closest('.pd-dm-top'))) {
      var li = el.closest('.pd-dm-it');
      if (!FINE && li.classList.contains('has-pan') && cur !== li) { e.preventDefault(); open(li); return; }
      return send('mall', deptOf(el));
    }
    if ((el = t.closest('[data-all]'))) return send('mall', deptOf(el));
    if ((el = t.closest('.pd-dm-trend a'))) return send('mitem', 'trending/' + slug(txt(el)));
    if ((el = t.closest('.pd-dm-l,a.pd-dm-h,.pd-dm-pic,.pd-dm-chip'))) {
      var nm = el.classList.contains('pd-dm-pic') ? txt(el.querySelector('span')) : txt(el), par = el.getAttribute('data-p');
      if (el.classList.contains('pd-dm-all')) return send('mall', deptOf(el) + '/' + slug(par));
      return send('mitem', deptOf(el) + '/' + (par ? slug(par) + '/' : '') + slug(nm));
    }
  }, true);
})();